import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f756850"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "type-container"
}
const _hoisted_3 = { class: "composer-option header" }
const _hoisted_4 = {
  key: 1,
  class: "composer-container"
}
const _hoisted_5 = { class: "composer-option header contents" }
const _hoisted_6 = { class: "names" }
const _hoisted_7 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_8 = {
  key: 1,
  ref: "recipients",
  class: "recipients"
}
const _hoisted_9 = {
  ref: "notice-composer-editor",
  class: "editor"
}
const _hoisted_10 = { class: "footer-container" }
const _hoisted_11 = { class: "notice-scheduler" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notice-scheduler-label" }, "Publish Schedule:", -1))
const _hoisted_13 = { class: "footer-button-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pin-notice-checkbox" }, "Pin notice", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_NoticeTypePicker = _resolveComponent("NoticeTypePicker")!
  const _component_SelectedRecipientPills = _resolveComponent("SelectedRecipientPills")!
  const _component_Quote = _resolveComponent("Quote")!
  const _component_ChatInput = _resolveComponent("ChatInput")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_DesktopRecipientPicker = _resolveComponent("DesktopRecipientPicker")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_NoticeSchedulerModal = _resolveComponent("NoticeSchedulerModal")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Modal, {
          class: "composer-modal",
          show: _ctx.show,
          vanilla: "",
          flex: "",
          "flex-direction": "column",
          close: _ctx.onClose,
          height: _ctx.modalHeight,
          "max-width": _ctx.maxModalWidth
        }, {
          default: _withCtx(() => [
            (_ctx.composingStep === 'type')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Typography, { variant: "subtitle1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Select Notice Type")
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_NoticeTypePicker, {
                    title: "Select Notice Type",
                    class: "notice-type-picker",
                    selected: _ctx.composer.type,
                    "has-last-divider": false,
                    onSelect: _ctx.onSelectNoticeType
                  }, null, 8, ["selected", "onSelect"])
                ]))
              : (_ctx.composingStep === 'message')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Typography, { variant: "subtitle1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.typeTitle), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    (_ctx.canPickRecipients)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "composer-option contents",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRecipientPicker()))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            (!_ctx.hasRecipients)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Add Recipients "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_SelectedRecipientPills, {
                                    recipients: _ctx.recipients,
                                    "selected-recipients": _ctx.selectedRecipients,
                                    "can-remove-tabs": false
                                  }, null, 8, ["recipients", "selected-recipients"])
                                ], 512))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.composer.question)
                        ? (_openBlock(), _createBlock(_component_Quote, {
                            key: 0,
                            text: _ctx.composer.question.comment || 'No Comment',
                            onQuoteClampChange: _ctx.scrollToEditor
                          }, null, 8, ["text", "onQuoteClampChange"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ChatInput, {
                        "html-mode": "",
                        "custom-class": "notice-editor",
                        class: "notice-editor-wrapper",
                        content: _ctx.editingMessage,
                        placeholder: "Write Notice",
                        "on-update": _ctx.onMessageUpdate,
                        mentions: _ctx.recipients,
                        "max-text-length": 301
                      }, null, 8, ["content", "on-update", "mentions"])
                    ], 512),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.canPickSchedule)
                          ? (_openBlock(), _createBlock(_component_Typography, {
                              key: 0,
                              variant: "subtitle2"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12,
                                _createElementVNode("span", {
                                  class: "notice-scheduler-value",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSchedule = true))
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.scheduledTimeLabel) + " ", 1),
                                  _createVNode(_component_FontAwesomeIcon, {
                                    class: "chevron",
                                    icon: _ctx.faChevronDown
                                  }, null, 8, ["icon"])
                                ])
                              ], undefined, true),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.$companyVars.has_huddle)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_14,
                              _withDirectives(_createElementVNode("input", {
                                id: "pin-notice-checkbox",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.composer.isPinned) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.composer.isPinned]
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (!_ctx.composer.question)
                          ? (_openBlock(), _createBlock(_component_BaseButton, {
                              key: 1,
                              class: "btn-back",
                              variant: "ghost",
                              onClick: _ctx.showNoticeTypePicker
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Back ")
                              ], undefined, true),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_BaseButton, {
                          disabled: !_ctx.canSend,
                          variant: "secondary",
                          onClick: _ctx.sendNoticeMessage
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.sendButtonLabel(_ctx.sendButtonTextOverride)), 1)
                          ], undefined, true),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ])
                  ]))
                : (_ctx.composingStep === 'recipient')
                  ? (_openBlock(), _createBlock(_component_DesktopRecipientPicker, {
                      key: 2,
                      single: false,
                      selected: _ctx.selectedRecipients,
                      recipients: _ctx.recipients,
                      "allow-empty": false,
                      title: "Add Recipients",
                      onClose: _ctx.onCancelRecipients,
                      onConfirm: _ctx.onConfirmRecipients
                    }, null, 8, ["selected", "recipients", "onClose", "onConfirm"]))
                  : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }, 8, ["show", "close", "height", "max-width"]),
        _createVNode(_component_NoticeSchedulerModal, {
          timezone: _ctx.timezone,
          show: _ctx.showSchedule,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSchedule = false)),
          onSchedule: _ctx.onScheduleTime
        }, null, 8, ["timezone", "show", "onSchedule"])
      ]))
    : _createCommentVNode("", true)
}